import styled from "styled-components/macro";

export const Toolbar = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.space[1]}px;
  margin-bottom: ${({ theme }) => theme.space[3]}px;
`;

export const SearchWrapper = styled.div`
  width: 260px;
`;

export const ColumnTitlesRow = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) 56px minmax(0, 1fr);
  align-items: center;
  margin-bottom: ${({ theme }) => theme.space[1]}px;
`;

export const ColumnTitleCell = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.space[1]}px;
  min-width: 0;
`;

export const Columns = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) 56px minmax(0, 1fr);
  align-items: stretch;
  border-top: 1px solid ${({ theme }) => theme.colors.gray78};
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

export const ColumnTitle = styled.div`
  font-weight: ${({ theme }) => theme.fontWeights.bold};
`;

export const ColumnHeader = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.space[1]}px;
  padding: ${({ theme }) => theme.space[1]}px ${({ theme }) => theme.space[2]}px;
  background: ${({ theme }) => theme.colors.gray95};
`;

export const ColumnHeaderText = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: baseline;
  gap: ${({ theme }) => theme.space[1]}px;
  white-space: nowrap;
  overflow: hidden;
`;

export const RowList = styled.div`
  height: 400px;
  overflow-y: auto;
  border-top: 1px solid ${({ theme }) => theme.colors.gray95};
`;

export const BuyerRow = styled.div<{ selected: boolean }>`
  display: flex;
  align-items: flex-start;
  gap: ${({ theme }) => theme.space[1]}px;
  padding: ${({ theme }) => theme.space[1]}px ${({ theme }) => theme.space[2]}px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.gray95};
  background: ${({ theme, selected }) =>
    selected ? theme.colors.blueHighlight : "transparent"};
  cursor: pointer;
`;

export const BuyerDetails = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
`;

export const MoveColumn = styled.div`
  border-left: 1px solid ${({ theme }) => theme.colors.gray78};
  border-right: 1px solid ${({ theme }) => theme.colors.gray78};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.space[1]}px;
`;

export const MoveButton = styled.button`
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${({ theme }) => theme.colors.gray78};
  background: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.gray44};
  cursor: pointer;

  &:disabled {
    color: ${({ theme }) => theme.colors.gray85};
    cursor: default;
  }
`;

export const EmptyColumnMessage = styled.p`
  padding: ${({ theme }) => theme.space[4]}px ${({ theme }) => theme.space[2]}px;
  text-align: center;
  color: ${({ theme }) => theme.colors.gray78};
  font-size: ${({ theme }) => theme.fontSizes.alpha}px;
`;
